<template>
  <Select filterable remote clearable
          @on-change="onChange" :placeholder="placeNum"
          :remote-method="remoteMethod" :loading="loading" transfer ref="store">
    <Option v-for="item in items"
            :value="item.num" :key="item.num">
            {{'+' + item.num + ' ' + item.name.cn}}
    </Option>
  </Select>
</template>
<script>
  export default {
    name: 'PhoneAreaSelect',
    props: {
      value: {
        type: [Number, String]
      },
      label: {
        type: String
      },
      areaNumValue: {
        type: Number
      }
    },
    data () {
      return {
        loading: false,
        model: this.value,
        items: null,
        arr: [],
        areaPhoneNum: '',
        placeNum: '',
      }
    },
    methods: {
      remoteMethod (query) {
        query = query === null ? '' : query.trim()
        if (query === null || query === '') {
          this.items = []
          return
        }
        let self = this
        self.arr = []
        self.loading = true
        self.areaNums = self.$phoneArea.areaNum
        for (var index = 0; index < self.areaNums.length; index++) {
          if (self.areaNums[index].name.cn.indexOf(query) >= 0 || self.areaNums[index].num === parseInt(query)) {
            self.arr.push(self.areaNums[index])
          } else if (self.areaNums[index].name.en.indexOf(query) >= 0) {
            self.arr.push(self.areaNums[index])
          } else if (self.areaNums[index].name.pinyin.indexOf(query) >= 0) {
            self.arr.push(self.areaNums[index])
          }
        }
        self.items = self.arr
        self.loading = false
      },
      onChange (value) {
        this.$emit('input', value)
        this.$emit('on-change', value)
      }
    },
    mounted: function () {
    },
    watch: {
      value (val) {
        this.model = val
      },
      areaNumValue (val) {
        this.$refs.store.clearSingleSelect()
        if (!val) {
          this.placeNum = ''
        }
        if (val) {
          this.placeNum = '+' + val
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PhoneAreaSelect.vue?a023f73a